import { node } from "~/util/dom";
import createSDSIcon from "~/ui/icon";
import { ICON_INFO_OUTLINE_16 } from "~/ui/icons";
import { _ } from "~/i18n";

const coopParams = `{
    "a": [
        {
            "p": "",
            "b": "",
            "r": [
                2
            ]
        }
    ]
}`;

function stringToBase64url(str: string) {
	const bytes = new TextEncoder().encode(str);
	const binString = Array.from(bytes, byte => String.fromCodePoint(byte)).join("");

	return btoa(binString).replace(/\+/gu, "-").replace(/\//gu, "_");
}

export function createCommercialCollaborationLink(): HTMLAnchorElement {
	return node("a", {
		target: "_blank",
		rel: "noopener noreferer",
		href: `https://ssp.seznam.cz/cooperation-info#${stringToBase64url(coopParams).replace(/=/gu, "")}`,
	});
}

export function createCommercialCollaboration({
	align = "left",
}: {
	align?: "left" | "right",
} = {}): HTMLAnchorElement {
	const link = createCommercialCollaborationLink();
	const text = node("span", {}, _("commercialCollaboration"));
	const infoIcon = createSDSIcon({ symbol: ICON_INFO_OUTLINE_16 });

	link.classList.add("ui-commercial-collaboration");

	if (align === "left") {
		link.append(infoIcon, text);
	} else {
		link.append(text, infoIcon);
	}

	return link;
}
